import ApiConstant from "../../../constants/api.constants";
import Helpers from "../../../utils/helpers";
import api from "../../api";

const baseURL = process.env.REACT_APP_SERVER_ENDPOINT_AURA_CAMERA; 

const getRouteInformation = async (cameraSiteId:any) => {
  try {
    const response = await api.get(`${baseURL}${ApiConstant.getRoutes}?cameraSiteId=${cameraSiteId}`);
    if (response && response.data ) {
      return response.data;
    }
  } catch (error) {
    Helpers.ConsoleLogError(error);
  }
}; 


const RouteOperationsService = {
    getRouteInformation,
};

export default RouteOperationsService;
